import { render, staticRenderFns } from "./CustomHtml.vue?vue&type=template&id=483dcbbc&scoped=true&"
import script from "./CustomHtml.vue?vue&type=script&lang=js&"
export * from "./CustomHtml.vue?vue&type=script&lang=js&"
import style0 from "./CustomHtml.vue?vue&type=style&index=0&id=483dcbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483dcbbc",
  null
  
)

export default component.exports